import { useEffect, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { AppHeader } from "../components/AppHeader";
import { ProjectCard } from "../components/ProjectCard";
import { statusOf } from "../components/StatusBadge";
import { useAuth } from "../context/AuthContext";
import { api, errorMessage } from "../lib/api";

const Section = ({ title, list, testId, nav }) => (
  <section data-testid={testId} className="space-y-3">
    <h2 className="font-heading text-lg font-semibold">{title} <span className="text-[#6B7280] font-normal">({list.length})</span></h2>
    {list.length === 0 ? (
      <p className="rounded-xl border border-dashed border-[#2D333F] p-6 text-sm text-[#9CA3AF]">Nenhum ambiente.</p>
    ) : (
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {list.map((p, i) => <ProjectCard key={p.id} p={p} i={i} prefix={`${testId}-project`} onOpen={() => nav(`/projeto/${p.id}`)} />)}
      </div>
    )}
  </section>
);

export default function UserProjects() {
  const { uid } = useParams();
  const { user } = useAuth();
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/admin/users/${uid}`).then((r) => setData(r.data)).catch(async (e) => setError(await errorMessage(e)));
  }, [uid]);

  if (user?.role !== "admin") return <Navigate to="/" replace />;
  const projects = data?.projects || [];
  return (
    <div className="min-h-screen">
      <AppHeader />
      <main className="px-4 sm:px-6 lg:px-8 py-10 max-w-6xl mx-auto space-y-8">
        <button data-testid="user-projects-back" onClick={() => nav("/")} className="flex items-center gap-1 text-sm text-[#9CA3AF] hover:text-white"><ArrowLeft className="w-4 h-4" /> Voltar</button>
        {error && <p data-testid="user-projects-error" className="text-red-400">{error}</p>}
        {!data && !error ? (
          <div className="flex items-center gap-2 text-[#9CA3AF]"><Loader2 className="w-4 h-4 animate-spin" /> Carregando…</div>
        ) : data && (
          <>
            <div data-testid="user-projects-header" className="fade-up">
              <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#E67E22]">Projetos do cliente</p>
              <h1 className="font-heading text-4xl sm:text-5xl font-extrabold tracking-tight mt-2">{data.user.name}</h1>
              <p className="text-[#9CA3AF] mt-2 font-mono text-sm break-all">{data.user.email}{data.user.phone ? ` · ${data.user.phone}` : ""}</p>
            </div>
            <Section title="Em andamento" testId="user-projects-open" nav={nav} list={projects.filter((p) => statusOf(p) === "editando")} />
            <Section title="Concluídos" testId="user-projects-done" nav={nav} list={projects.filter((p) => statusOf(p) !== "editando")} />
          </>
        )}
      </main>
    </div>
  );
}
